// extracted by css-extract-rspack-plugin
export default {"root":"W2lYlV","message":"L21vzs"};